import { result, map } from 'underscore';
import { odata } from '@bingads-webui/http-util';
import config from '@bingads-webui-component-legacy/config/index';

export const getAdUnitData = async () => {
  const cid = result(config.get('CurrentCustomer'), 'Id');
  const aid = result(config.get('CurrentAccount'), 'Id');
  const url = `${config.get('odata.url')}${config.get('odata.path')}/Customers(${cid})/Accounts(${aid})/AdUnit`;

  return odata.get(url, { oDataToken: config.get('odata.token') })
    .then(response => map(response.value, item => ({ key: item.Key, name: item.Name })));
};

const getTriggerI18nMapping = i18n => ({
  NoTrigger: i18n.getString(_TL_('No trigger')),
  UserIdle5Seconds: i18n.getString(_TL_('User Idle (5 seconds)')),
  AppOpenEdge: i18n.getString(_TL_('App Open - Edge')),
  AppOpenExcel: i18n.getString(_TL_('App Open - Excel')),
  AppOpenExcel2016: i18n.getString(_TL_('App Open - Excel 2016')),
  AppOpenPowerPoint: i18n.getString(_TL_('App Open - Power Point')),
  AppOpenPowerPoint2016: i18n.getString(_TL_('App Open - Power Point 2016')),
  AppOpenWordAll: i18n.getString(_TL_('App Open - Word all')),
  AppClosePhotoApp: i18n.getString(_TL_('App Close - Photo app')),
  UserIdle30Seconds: i18n.getString(_TL_('User Idle (30 seconds)')),
  UserIdle5Min: i18n.getString(_TL_('User Idle (5 min)')),
  AppClosedOneDrive: i18n.getString(_TL_('App Closed - OneDrive')),
  AppClosedSettings: i18n.getString(_TL_('App Closed - Settings')),
  AppOpenOneDrive: i18n.getString(_TL_('App Open - OneDrive')),
  AppOpenSettings: i18n.getString(_TL_('App Open - Settings')),
  AppOpenStore: i18n.getString(_TL_('App Open - Store')),
  AppOpenWord2016: i18n.getString(_TL_('App Open - Word 2016')),
  AppOpenXbox: i18n.getString(_TL_('App Open - Xbox')),
  CustomerOpensEdge: i18n.getString(_TL_('Customer opens edge')),
  DeviceUnlock: i18n.getString(_TL_('Device unlock')),
  EdgeExtensionInstalled: i18n.getString(_TL_('Edge Extension installed')),
  UserAddsFavorite: i18n.getString(_TL_('User adds Favorite')),
  UserClosesATabAndHasAtLeast3TabsOpen: i18n.getString(_TL_('User closes a tab and has at least 3 tabs open')),
  UserOpensPhotosApp: i18n.getString(_TL_('User opens photos app')),
});

export const getTriggerIdsData = async (i18n, isBoostTriggerEnabled) => {
  if (!isBoostTriggerEnabled) {
    return [];
  }

  const cid = result(config.get('CurrentCustomer'), 'Id');
  const aid = result(config.get('CurrentAccount'), 'Id');
  const url = `${config.get('odata.url')}${config.get('odata.path')}/Customers(${cid})/Accounts(${aid})/BoostTriggers`;
  const i18nMapping = getTriggerI18nMapping(i18n);

  const data = odata.get(url, { oDataToken: config.get('odata.token') });

  return data.then(response => map(response.value, item => ({ key: String(item.Key), text: i18nMapping[item.Name] || item.Name })));
};

